import { Button, Menu, Text } from "@mantine/core";
import { IconArrowsLeftRight, IconStatusChange } from "@tabler/icons-react";
import {
  User,
  isUserProvider,
  isUserStaff,
  OrderStatus as SharedOrderStatus,
  UserType,
  displayStatusName,
} from "@jasper/shared";

import { OrderStatus } from "../../../generated/graphql";
import { useState } from "react";
import { PROVIDER_ALLOWED_STATUSES } from "../../../constants/orders";

interface Props {
  user: User;

  updateStatuses: (status: OrderStatus) => void;
  filteredStatuses?: OrderStatus[];

  syncOrdersFrom3Shape: () => void;
}

export const ActionsButton = ({
  user,
  updateStatuses,
  filteredStatuses = [],
  syncOrdersFrom3Shape,
}: Props) => {
  const [subOpened, setSubOpened] = useState(false);

  return (
    <Menu>
      <Menu.Target>
        <Button>Actions</Button>
      </Menu.Target>

      <Menu.Dropdown>
        {user.type === UserType.JASPER && (
          <Menu.Item
            leftSection={<IconArrowsLeftRight size={14} />}
            onClick={syncOrdersFrom3Shape}
          >
            Sync orders from 3Shape
          </Menu.Item>
        )}

        <Menu.Item
          leftSection={<IconStatusChange size={14} />}
          onMouseEnter={() => setSubOpened(true)}
          onMouseLeave={() => setSubOpened(false)}
        >
          <Menu opened={subOpened} position="left-start">
            <Menu.Target>
              <Text size="sm">Update Statuses</Text>
            </Menu.Target>
            <Menu.Dropdown>
              {Object.values(OrderStatus)
                .filter(status => {
                  const isCurrentStatus = filteredStatuses.includes(status);
                  const isStaffUser = isUserStaff(user);
                  const isProviderWithAllowedStatus =
                    isUserProvider(user) &&
                    PROVIDER_ALLOWED_STATUSES.includes(status);

                  return (
                    !isCurrentStatus &&
                    (isStaffUser || isProviderWithAllowedStatus)
                  );
                })
                .map(status => (
                  <Menu.Item
                    key={status}
                    onClick={() => updateStatuses(status)}
                  >
                    {displayStatusName(
                      status as unknown as SharedOrderStatus,
                      user
                    )}
                  </Menu.Item>
                ))}
            </Menu.Dropdown>
          </Menu>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
